/** @flow */
import { fromJS, Map, List } from 'immutable';

import * as ActionType from './actions';
import getErrorMessage from './getErrorMessage';


const defaultState = fromJS({
  lastId: 0,
  queue: [],
  lastMessage: null,
  lastMessageTime: 0,
  lastShapeDefinition: null,
});


export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case ActionType.ADD_API_ERROR: {
      const message = getErrorMessage(action);
      const now = Date.now();

      const rp = action?.requestParams;
      const requestShapeDef = rp?.shapeDefinition || rp?.query?.shapeDefinition;

      const lastMsg = state.get('lastMessage');
      const lastTime = state.get('lastMessageTime');
      const lastShapeDef = state.get('lastShapeDefinition');

      const shapeDefStr = requestShapeDef ? JSON.stringify(requestShapeDef) : null;
      const lastShapeDefStr = lastShapeDef ? JSON.stringify(lastShapeDef) : null;

      const isSameShape = shapeDefStr && lastShapeDefStr === shapeDefStr;
      const isSameTimeFrame = (now - lastTime) < 5000;
      const isShapeError = message && message.includes('5000');

      if (lastMsg && message && lastMsg === message && (isSameShape || (isShapeError && isSameTimeFrame))) {
        return state;
      }

      return state
        .update('lastId', (id) => ((id) + 1))
        .set('lastMessage', message)
        .set('lastMessageTime', now)
        .set('lastShapeDefinition', requestShapeDef || null)
        .update('queue', (errors) => (errors)
          .push(fromJS({
            id: action.id || state.get('lastId'),
            message,
            action,
          })),
        );
    }

    case ActionType.REMOVE_API_ERROR:
      return state.update('queue', (errors) => errors.filter(error => error.get('id') !== action.id));

    case ActionType.REMOVE_ALL_ERRORS:
      return state.set('queue', defaultState.get('queue'));

    default:
      return state;
  }
}
